const gyms = (state) => state.gyms;

export default gyms;
